if (document.querySelectorAll('[data-component="copy"]').length > 0) {
    
    document.addEventListener('DOMContentLoaded', function () {

        // Main functionality
        function copyText(element) {
            var textToCopy = element.innerText;
            var myTemporaryInputElement = document.createElement("input");
            myTemporaryInputElement.type = "text";
            myTemporaryInputElement.value = textToCopy;
            document.body.appendChild(myTemporaryInputElement);
            myTemporaryInputElement.select();
            document.execCommand("Copy");
            document.body.removeChild(myTemporaryInputElement);
        };

        // Add class to copied element to denote success
        function flashElement(element) {
            element.classList.add("copy-flash");
            
            document.addEventListener("transitionend", function() {
                setTimeout(function() {
                element.classList.remove("copy-flash");
                }, 1000);
            });
        };
        
        document.querySelectorAll('[data-component="copy"]').forEach(function(el){
            // Add click event listener for clicking the text
            el.addEventListener('click', function (e) {
                var element = e.target;
                flashElement(element);
                copyText(element);
            });
        });
        
    });
}